import React from 'react';
import PropTypes from 'prop-types';

import styles from './Ribbon.module.scss';

function Ribbon({ label, color, size }) {
  const getFontSize = (text) => {
    const calc = ((8 * 13.5) / text.length) + 2;
    const max = size === 'small' ? 12 : 16;
    return calc > max ? max : calc;
  };

  return label ? (
    <div className={styles.ribbon_holder}>
      <div
        className={`${styles.ribbon} ${color ? styles[color] : ''} ${size ? styles[size] : ''}`}
        style={{ fontSize: `${getFontSize(label)}px` }}
      >
        {label}
      </div>
    </div>
  ) : null;
}

Ribbon.propTypes = {
  label: PropTypes.string.isRequired,
  color: PropTypes.oneOf(['orange']),
  size: PropTypes.oneOf(['small']),
};

Ribbon.defaultProps = {
  color: null,
  size: null,
};

export default Ribbon;
